import useClickOutside from "hooks/useClickOutside";
import useWheel from "hooks/useWheel";
import React, { startTransition, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Dropdown from "./dropdown";

export { Dropdown };

const COMMON_PADDING = 5;

const Popup = (props) => {
    const { Component, children, openedCallback, openOnDoubleClick } = props;

    const lastTimeTap = useRef(0);
    const childrenRef = useRef(null);
    const innerRef = useRef(null);

    const [opened, setOpened] = useState(false);
    const [clickLocation, setClickLocation] = useState({});
    const [componentLocation, setComponentLocation] = useState({});

    const componentStyle = {
        position: "fixed",
        top: componentLocation.y || 0,
        left: componentLocation.x || 0,
        zIndex: 999,
    };

    useLayoutEffect(() => {
        if (!opened) {
            return;
        }

        calculateLocation();
    }, [opened]);

    useClickOutside(innerRef, () => startTransition(() => setOpenedWrapper(false)));
    useWheel((e) =>
        startTransition(() => {
            if (!e.srcElement.closest(".popup-dropdown")) {
                setOpenedWrapper(false);
            }
        }),
    );

    const calculateLocation = () => {
        const documentWidth = window.innerWidth;
        const documentHight = window.innerHeight;

        const componentRect = innerRef.current.getBoundingClientRect();
        const childrenRect = childrenRef.current.getBoundingClientRect();

        let x = clickLocation.x - componentRect.width / COMMON_PADDING; // COMMON_PADDING - отступ от 1/5 ширины компонента
        let y = childrenRect.y + childrenRect.height + COMMON_PADDING; // COMMON_PADDING - доп отступ от children (для красоты)

        if (x < 0) {
            x = COMMON_PADDING;
        } else if (x + componentRect.width > documentWidth) {
            x = documentWidth - componentRect.width - COMMON_PADDING;
        }

        if (y + componentRect.height > documentHight) {
            y = childrenRect.y - componentRect.height - COMMON_PADDING;
        }

        setComponentLocation({ x, y });
    };

    const setOpenedWrapper = (newValue) => {
        setOpened(newValue);
        openedCallback?.(newValue);
    };

    const handleChildrenClick = (event) => {
        const { clientX, clientY } = event;

        setOpenedWrapper(!opened);
        setClickLocation({ x: clientX, y: clientY });
    };

    // даблклик на мобилке
    const handleChildrenMobileClick = (event) => {
        const now = Date.now();

        // ничего не делаем, если время между нажатиями больше 300 мс
        if (now - lastTimeTap.current > 300) {
            lastTimeTap.current = now;
            return;
        }

        handleChildrenClick(event);
    };

    return (
        <>
            {React.cloneElement(children, {
                ref: childrenRef,
                onClick: openOnDoubleClick ? handleChildrenMobileClick : handleChildrenClick,
                // в мобилке он эмулирует onClick
                // если открыт попап и хотят закрыть элемент нажимая на тот же элемент, то она закрывается и вызывается заново
                onTouchStart: (event) => {
                    event.stopPropagation();
                },
            })}
            {opened &&
                createPortal(
                    <Component
                        style={componentStyle}
                        innerRef={innerRef}
                        setOpened={setOpenedWrapper}
                        childrenRef={childrenRef}
                        clickLocation={clickLocation}
                        componentLocation={componentLocation}
                    />,
                    document.body,
                )}
        </>
    );
};

export default Popup;
